import { network } from 'services/network';

export const getReportExecSummary = (params) => {
    return network.post('api/bo/reporting/getReportExecSummary', params).then((response) => {
        return response.data;
    });
};
